import styled from 'styled-components'
import { Link } from 'react-router-dom'

export const Container = styled.div`
  display: flex;
  flex-direction: row;
  gap: 5px;
  margin-left: 5px;
  margin-bottom: 10px;
  align-items: center;
`

export const HeaderText = styled.div`
  color: #d5dceb;
  font-weight: 500;
  flex-grow: 1;
  margin-left: 5px;
`

export const ViewAllLink = styled(Link)`
  color: #3ccea2;
  font-size: 0.875rem;
  font-weight: 500;
  margin-right: 8px;

  &:hover {
    color: #219473;
  }
`

export const NavigationButton = styled.button<{ $isMobile: boolean; disabled: boolean }>`
  display: ${(props) => (props.$isMobile ? 'none' : 'flex')};
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border-radius: 6px;
  background-color: #2a2a2a;
  color: white;
  border: none;
  cursor: ${(props) => (props.disabled ? 'not-allowed' : 'pointer')};
  opacity: ${(props) => (props.disabled ? 0.5 : 1)};

  &:hover {
    background-color: ${(props) => (props.disabled ? '#2a2a2a' : '#3a3a3a')};
  }
`
